import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./GoodToKnow.scss";

const GoodToKnow = ({ description }) => {
	return (
		<div className="good-to-know">
			<h4 className="good-to-know__headline">
				<FormattedMessage id="useful.information.good.to.knows.headline" />
			</h4>
			<div className="good-to-know__description">
				<Paragraphs paragraphs={description} enableHTMLFormatting={true} />
			</div>
		</div>
	);
};

GoodToKnow.propTypes = {
	description: PropTypes.arrayOf(PropTypes.string),
};

GoodToKnow.defaultProps = {
	description: [],
};

export default memo(GoodToKnow);
